export default __webpack_public_path__ + "images/PRM.4fea702.png";